// Workspaces: every workspace, grouped by environment (the mocks show them on their
// environment's page; this route stays for links and the terminal).
import { FolderSimple } from "@phosphor-icons/react";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router";

import { environmentsQuery, orgsQuery, workspacesQuery } from "../api/queries";
import { useT } from "../i18n";
import { WidgetCard } from "../ui/Card";
import { PageHeader } from "../ui/PageHeader";
import { EmptyState, ErrorState, Loading } from "../ui/states";
import { WorkspaceCard } from "../workloads/environment/WorkspaceCard";
import { sectionCrumbs } from "../layout/nav";

export default function WorkspacesPage() {
  const { workloads } = useT();
  const t = workloads.workspaces;
  const workspaces = useQuery(workspacesQuery());
  const environments = useQuery(environmentsQuery());
  const orgs = useQuery(orgsQuery());
  const groups = (environments.data ?? [])
    .map((env) => ({ env, items: (workspaces.data ?? []).filter((w) => w.environment_id === env.id) }))
    .filter((g) => g.items.length > 0);

  return (
    <>
      <PageHeader
        title={t.title}
        breadcrumb={sectionCrumbs("workspaces")}
        description={t.description}
      />
      {workspaces.isPending ? <Loading /> : null}
      {workspaces.isError ? <ErrorState message={workspaces.error.message} /> : null}
      {workspaces.data?.length === 0 ? (
        <EmptyState icon={<FolderSimple weight="duotone" />} title={t.emptyTitle}>
          {t.emptyBody}
        </EmptyState>
      ) : null}
      <div className="space-y-5">
        {groups.map(({ env, items }) => (
          <WidgetCard
            key={env.id}
            label={env.name}
            title={`${orgs.data?.find((o) => o.id === env.org_id)?.name ?? "—"} / ${env.name}`}
            action={
              <Link to={`/environments/${env.id}`} className="text-[13px] font-medium text-primary">
                {t.environmentLink}
              </Link>
            }
          >
            <div className="space-y-3">
              {items.map((w) => (
                <WorkspaceCard key={w.id} workspace={w} />
              ))}
            </div>
          </WidgetCard>
        ))}
      </div>
    </>
  );
}
